export default "__VITE_ASSET__fVoZa0Rs__"